export enum ImageItemPanels {
  NONE = 'none',
  SHADOW = 'shadow',
  GLOW = 'glow',
  BORDER = 'border',
  REMOVE_COLOR = 'remove-color',
  TINT = 'tint',
  MULTIPLY = 'multiply',
  ANIMATION = 'animation',
}
